import { useAppDispatch, useAppSelector } from '@src/redux/hooks.ts';
import FJModal from '@src/components/FJModals/FJModal';
import styles from '@src/components/FJModals/FJAdjustDurationModal/index.module.less';
import FJModalClose from '@src/components/FJModals/FJModalClose/FJModalClose.tsx';
import FJContentView from '@src/components/FJModals/FJAdjustDurationModal/modules/FJContentView.tsx';
import FJFootContainer from '@src/components/FJModals/FJAdjustDurationModal/foot/FJFootContainer.tsx';
import FJTrimAction from '@src/redux/action/FJTrimAction.ts';

const FJAdjustDurationModalContainer = () => {
    const dispatch = useAppDispatch();
    const { isShow, title } = useAppSelector(state => {
        const s = state.modal.cut;
        // 如果 loadingState 是布尔值，则没有 message
        return { isShow: s.isShow, title: s.title };
    });

    const onClose = () => {
        dispatch(FJTrimAction.cancelAction(true));
    };

    return (
        <FJModal
            width='1200px'
            height={'auto'}
            borderRadius={20}
            backgroundColor={'transparent'}
            boxShadow={'none'}
            visible={isShow}
        >
            <div className={styles.box}>
                <FJModalClose onClick={onClose} />
                <p className={styles.header}>{title}</p>
                <FJContentView />
                {/*<FJThumbnailContainer />*/}
                <FJFootContainer />
            </div>
        </FJModal>
    );
};

export default FJAdjustDurationModalContainer;
